export default {
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  LOGIN_USER_FAILURE: 'LOGIN_USER_FAILURE',
  LOGIN_USER_REQUEST: 'LOGIN_USER_REQUEST',
  LOGIN_AUTH_CALLBACK_REQUEST: 'LOGIN_AUTH_CALLBACK_REQUEST',
  LOGOUT_USER: 'LOGOUT_USER',
  VERIFY_EMAIL_FAILURE: 'VERIFY_EMAIL_FAILURE',
  VERIFY_EMAIL_SUCCESS: 'VERIFY_EMAIL_SUCCESS',
};
